import React, { useState, useEffect } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Hint, Text, PageSubTitle } from 'components/common/Elements/Elements';

import classes from './DimensionTable.module.scss';

const DimensionTable = ({ tableData }) => {
  const [trQuantity, setTrQuantity] = useState([]);
  const { t } = useTranslation(['activity']);

  const tooltipText = `The color represents the score given by comparing other customers in the ${tableData[0].tooltipPlan} plan and ${tableData[0].tooltipAge} age tier`;

  useEffect(() => {
    let maxTrLength = 0;
    tableData.forEach(el => {
      if (el.tooltipData.length > maxTrLength)
        maxTrLength = el.tooltipData.length;
    });
    let counterArr = [];
    for (let i = 0; i < maxTrLength; i += 1) {
      counterArr.push(i);
    }
    setTrQuantity(counterArr);
  }, [tableData]);

  return (
    <section className={classes.wrap}>
      {tableData.length > 0 && (
        <div className={classes.table_header}>
          <PageSubTitle title=" Health Score Dimension and Parameters" />
          <Hint className={classes.hint} text={tooltipText} position="top" />
        </div>
      )}
      <section
        style={{
          width: tableData.length <= 2 ? `${400 * tableData.length}px` : '100%'
        }}
        className={classes.groupTables}
      >
        {tableData.map((item, index) => (
          <table
            className={cn(
              classes.table,
              index !== tableData.length - 1 && classes.table_border,
              tableData.length <= 2 && classes.table_small
            )}
            key={item.name}
          >
            <thead>
              <tr className={classes.trHeader}>
                <th colSpan="2" className={classes.thHeader}>
                  {item.name}
                </th>
              </tr>
            </thead>
            <tbody>
              {trQuantity.map(el => (
                <tr
                  className={classes.trBody}
                  key={el}
                  style={{
                    backgroundColor:
                      item.tooltipData[el] && item.tooltipData[el].bgColor
                  }}
                >
                  <td
                    className={cn(
                      classes.tdBody,
                      el !== trQuantity.length - 1 && classes.tdBody_lastTd
                    )}
                  >
                    <Text weight="b">
                      {item.tooltipData[el] &&
                        (item.tooltipData[el].parameter !== 'Siem Integration'
                          ? item.tooltipData[el].parameter
                          : t('activity:customers.SIEM_INTEGRATION'))}
                    </Text>
                  </td>
                  <td
                    className={cn(
                      classes.tdBody,
                      el !== trQuantity.length - 1 && classes.tdBody_lastTd,
                      classes.textRight
                    )}
                  >
                    <Text
                      className={
                        item.tooltipData[el] &&
                        typeof item.tooltipData[el].value === 'boolean'
                          ? classes.trBody_uppercase
                          : null
                      }
                    >
                      {item.tooltipData[el] &&
                        String(item.tooltipData[el].value)}
                    </Text>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </section>
    </section>
  );
};

DimensionTable.propTypes = {
  tableData: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.bool])
};

export default DimensionTable;
